import React from 'react'
import { Slide, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { forwardRef } from 'react'
import { Col, Row } from 'react-bootstrap'
import { mainOptions } from '../../../../../utils/MuiDataTable'
import moment from 'moment-jalaali'
import { useDispatch, useSelector } from 'react-redux'
import { useGetAllBuyers } from '../../../../components/customHooks/users/userHooks'
import { Skeleton } from '@material-ui/lab'
import { useState } from 'react'
import { CircularProgress} from "@material-ui/core";
const ProductBuyersList = ({id}) => {

  const { allBuyers, loading } = useGetAllBuyers(id);

  const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />
  })

  const customOptions = {
    responsive: 'standard',
    textLabels: {
      ...mainOptions.textLabels,
      body: {
        noMatch: 'متاسفانه داده ای یافت نشد',
      },
    },
    selectableRows: 'none',
    pagination: false,
    resizableColumns: false,
    filterType: 'dropdown',
    fixedHeader: true,
    serverSide: true,
    filter: false,
    print: false,
    download: false,
    onDownload: (buildHead, buildBody, columns, data) => {
      return false;
    },
  };

  const columns = [
    {
      name: 'ردیف',
      options: {
        sort: false,
      },
    },
    {
      name: 'نام خریدار',
    },
    {
      name: 'باقی مانده',
      options: {
        sort: false,
      },
    },
    {
      name: 'تاریخ ثبت سفارش',
      options: {
        sort: false,
      },
    },
  ]

  const options = { ...mainOptions, ...customOptions }

  return (
    <Row className='my-3'>
      <Col className='text-center'>
        {loading ? (
          <CircularProgress/>
        ): (
          <MUIDataTable
          columns={columns}
          options={options}
          data={
            allBuyers &&
            allBuyers?.map((row, index) => {
              return [
                ++index,
                row?.order?.purchaser?.name,
                row?.number_of_left,
                moment(row?.created_at).format('jYYYY/jM/jD HH:mm:ss'),
              ]
            })
          }
        />
        )}
      </Col>
    </Row>
  )
}

export default ProductBuyersList
